import React, { Fragment, useContext, useState } from "react";

import { AuthContext } from "./contexts/AuthContextProvider";
import { UserContext } from "./contexts/UserContextProvider";
import { PMSPharmacyContext } from "./contexts/pms_contexts/PMSPharmacyContext";
import { DeviceContext } from "./contexts/DeviceContextProvider";
import redirectToErrorPage from "./components/pages/os/error_pages/RedirectToErrorPage";
import { USER_TYPE } from "./helpers/Constants";

import axios from "axios";

export default () => {

    const [statusCode, setStatusCode] = useState(200);
    const authContext = useContext(AuthContext);
    const userContext = useContext(UserContext);
    const pmsPharmacyContext = useContext(PMSPharmacyContext);
    const deviceContext = useContext(DeviceContext);

    const { deviceId, maxDevices } = deviceContext;


    // Add a request interceptor
    axios.interceptors.request.use(function (config) {
        // Do something before request is sent
        // console.log("axios request called====>", config);

        const user = userContext?.user;

        // Check if user is not SYSTEM_ADMIN before adding headers
        if (user && user.userType !== USER_TYPE.SYSTEM_ADMIN) {
            // Add device information
            if (deviceId) {
                config.headers['device-id'] = deviceId;
            }

            // Add max devices
            if (maxDevices) {
                config.headers['Max-Device'] = maxDevices;
            }

            // Add pharmacy ID
            const pharmacyId = pmsPharmacyContext?.selectedPharmacy?.id;
            if (pharmacyId) {
                config.headers['pharmacy-id'] = pharmacyId;
            }

            // Add user ID
            if (user?.id) {
                config.headers['user-id'] = user.id;
            }
        }

        return config;
    }, function (error) {
        // Do something with request error
        return Promise.reject(error);
    });

    // Add a response interceptor
    axios.interceptors.response.use(function (response) {
        // Do something with response data
        // console.log("axios response called====>", response);

        return response;
    }, function (error) {
        // Do something with response error
        if (error.response && error.response.status === 401)
            authContext.logoutRequest();

        if (error.response && error.response.status === 403)
            setStatusCode(403)

        if (error.response && error.response.status === 500)
            setStatusCode(500)


        return Promise.reject(error);
    });

    return (
        <Fragment>
            {
                redirectToErrorPage(statusCode, authContext)
            }
        </Fragment>
    )
}

//BGW22272020020449370